import React from 'react';

// Generic line-art survey instruments for the logged-out hero (no real brand's design or logo).
const S = '#427898';
const F = 'rgba(66,120,152,0.10)';
const POINT = '#EF4444';

/** Total station on a tripod, set up over a survey point. */
export function TotalStation({ width = 130 }) {
    return (
        <svg width={width} height={width * 240 / 130} viewBox="0 0 130 240" fill="none" aria-hidden="true">
            {/* carrying handle */}
            <path d="M50 16 V8 H80 V16" stroke={S} strokeWidth="2.5" strokeLinejoin="round" />
            {/* standards (yoke) */}
            <rect x="33" y="16" width="14" height="60" rx="4" fill={F} stroke={S} strokeWidth="2.5" />
            <rect x="83" y="16" width="14" height="60" rx="4" fill={F} stroke={S} strokeWidth="2.5" />
            {/* telescope, slightly tilted, with objective lens */}
            <g transform="rotate(-9 65 42)">
                <rect x="38" y="31" width="52" height="22" rx="8" fill="#fff" stroke={S} strokeWidth="2.5" />
                <circle cx="91" cy="42" r="11" fill="#fff" stroke={S} strokeWidth="2.5" />
                <circle cx="91" cy="42" r="5.5" fill={F} stroke={S} strokeWidth="1.5" />
                <path d="M44 42 H60" stroke={S} strokeWidth="1.5" strokeLinecap="round" />
            </g>
            {/* body with display and keys */}
            <rect x="28" y="76" width="74" height="27" rx="6" fill={F} stroke={S} strokeWidth="2.5" />
            <rect x="37" y="82" width="32" height="15" rx="2" fill="#fff" stroke={S} strokeWidth="1.5" />
            <path d="M41 88 H58 M41 92 H52" stroke="#2EC4B6" strokeWidth="1.6" strokeLinecap="round" />
            {[[78, 85], [86, 85], [94, 85], [78, 93], [86, 93], [94, 93]].map(([x, y]) => <circle key={`${x}${y}`} cx={x} cy={y} r="1.7" fill={S} />)}
            {/* tribrach with foot screws */}
            <rect x="36" y="103" width="58" height="8" rx="3" fill="#fff" stroke={S} strokeWidth="2.5" />
            <circle cx="42" cy="115" r="2.5" fill={S} /><circle cx="65" cy="115" r="2.5" fill={S} /><circle cx="88" cy="115" r="2.5" fill={S} />
            {/* tripod head and legs (with clamps) */}
            <path d="M26 118 H104 L97 127 H33 Z" fill={F} stroke={S} strokeWidth="2.5" strokeLinejoin="round" />
            <path d="M40 127 L12 230 M65 127 V233 M90 127 L118 230" stroke={S} strokeWidth="3" strokeLinecap="round" />
            <path d="M26 175 l8 2 M65 178 h8 M104 175 l-8 2" stroke={S} strokeWidth="5" strokeLinecap="round" opacity="0.55" />
            {/* plumb line to the survey point */}
            <path d="M65 127 V228" stroke={POINT} strokeWidth="1" strokeDasharray="2 3" opacity="0.7" />
            <path d="M60 233 L70 233 M65 228 V238" stroke={POINT} strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

/** GNSS rover: antenna on a pole with a data collector, receiving satellite signal. */
export function GnssRover({ width = 110 }) {
    return (
        <svg width={width} height={width * 262 / 110} viewBox="0 0 110 262" fill="none" aria-hidden="true">
            {/* satellite + signal */}
            <g transform="translate(70 4) rotate(25)">
                <rect x="6" y="5" width="10" height="10" rx="2" fill="#fff" stroke={S} strokeWidth="1.8" />
                <rect x="-6" y="7" width="10" height="6" rx="1" fill={F} stroke={S} strokeWidth="1.5" />
                <rect x="18" y="7" width="10" height="6" rx="1" fill={F} stroke={S} strokeWidth="1.5" />
            </g>
            <path d="M40 20 Q55 10 70 20" stroke="#2EC4B6" strokeWidth="2.2" strokeLinecap="round" />
            <path d="M33 13 Q55 -1 77 13" stroke="#2EC4B6" strokeWidth="2.2" strokeLinecap="round" opacity="0.6" />
            {/* antenna */}
            <path d="M31 40 Q31 54 55 56 Q79 54 79 40" fill={F} stroke={S} strokeWidth="2.5" />
            <ellipse cx="55" cy="40" rx="24" ry="8" fill="#fff" stroke={S} strokeWidth="2.5" />
            <path d="M47 40 H63" stroke={S} strokeWidth="1.5" strokeLinecap="round" />
            {/* pole */}
            <path d="M55 56 V246" stroke={S} strokeWidth="3.2" strokeLinecap="round" />
            <path d="M51 246 L55 256 L59 246 Z" fill={S} />
            {/* data collector on its bracket */}
            <path d="M55 124 H62" stroke={S} strokeWidth="2.5" />
            <rect x="62" y="104" width="28" height="40" rx="5" fill="#fff" stroke={S} strokeWidth="2.5" />
            <rect x="66" y="109" width="20" height="17" rx="2" fill={F} stroke={S} strokeWidth="1.3" />
            <path d="M69 114 l4 4 l8 -6" stroke="#2EC4B6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            {[[70, 132], [76, 132], [82, 132], [70, 138], [76, 138], [82, 138]].map(([x, y]) => <circle key={`${x}${y}`} cx={x} cy={y} r="1.5" fill={S} />)}
            {/* circular level */}
            <circle cx="55" cy="176" r="6" fill="#fff" stroke={S} strokeWidth="2" />
            <circle cx="55" cy="176" r="2" fill="#2EC4B6" />
            {/* the point being measured */}
            <ellipse cx="55" cy="256" rx="14" ry="3.5" stroke={POINT} strokeWidth="1.5" strokeDasharray="3 2" />
        </svg>
    );
}
